import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { FaHeart, FaRegHeart, FaReply, FaLock, FaCommentAlt, FaRegCommentAlt } from "react-icons/fa";
import { AiOutlineLoading } from "react-icons/ai";
import { getMyCapsules, getCapsuleRecallQuestion, requestOpenCapsule, giveReaction, giveComment } from "../../../api/Capsule.api";
import RecallQuestionModal from "component/RecallQuestionModal";
import "./style.scss";
import { getUserInfo } from "utils/localStorage";


const MyCapsulePage = () => {
  const user = getUserInfo();
  const [capsules, setCapsules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [likedCapsules, setLikedCapsules] = useState({}); // To manage liked capsules
  const [replies, setReplies] = useState({}); // To manage replies for posts
  const [error, setError] = useState(null);
  const [selectedCapsule, setSelectedCapsule] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [showComments, setShowComments] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const { mode = "all" } = useParams();
  const toggleComments = () => {
    setShowComments((prev) => !prev);
  };

  useEffect(() => {
    const fetchCapsules = async () => {
      try {
        setLoading(true);
        let statusFilter = undefined;
        if (mode === "posted") statusFilter = "Opened";
        else if (mode === "pending") statusFilter = "Locked";

        const data = await getMyCapsules(1, 10, statusFilter)
        setCapsules(data.data);
      } catch (err) {
        setError("Sign in to modify your capsules.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCapsules();
  }, [mode]);

  const handleLike = async (postId, reactionType = "Heart") => {
    try {
      const response = await giveReaction(postId, reactionType); // Call the API
      console.log(`${reactionType} reaction response:`, response);
      setLikedCapsules((prev) => ({
        ...prev,
        [postId]: !prev[postId], // toggle trạng thái
      }));
    } catch (error) {
      console.error(`Error reacting with "${reactionType}" to post:`, error);
      alert(`Failed to react with "${reactionType}". Please try again.`);
    }
  };

  const handleReply = async (postId) => {
    if (!replies[postId]?.trim()) return; // Ensure the reply is not empty

    try {
      const commentText = replies[postId]; // Get the reply text
      const response = await giveComment(postId, commentText); // Call the API
      console.log("Reply response:", response);
      alert("Your comment has been posted!");
      setReplies((prev) => ({ ...prev, [postId]: "" })); // Clear the reply input
    } catch (error) {
      console.error("Error posting reply:", error);
      alert("Failed to post your comment. Please try again.");
    }
  };

  const handleOpenCapsule = async (capsuleId) => {
    try {
      console.log("Button clicked to open capsule:", capsuleId);
      const questions = await getCapsuleRecallQuestion(capsuleId);
      setQuestions(questions.data); // Assuming the API returns a `questions` array
      setSelectedCapsule(capsuleId); // Open the modal
      console.log("Recall questions received:", questions.data);

    } catch (error) {
      console.error("Failed to fetch recall questions:", error);
      alert("Failed to fetch recall questions. Please try again.");
    }
  };

  const handleModalClose = () => {
    setSelectedCapsule(null);
    setQuestions([]);
  };

  const handleModalSuccess = async () => {
    try {
      if (selectedCapsule) {
        await requestOpenCapsule(selectedCapsule); // Call the API to open the capsule
        alert("All questions answered successfully! Capsule opened.");
        window.location.reload(); // Refresh the page
      }
    } catch (error) {
      console.error("Error opening capsule:", error);
      alert("Failed to open the capsule. Please try again.");
    }
  };

  if (loading) return <div className="loading-wrapper"><AiOutlineLoading className="loading-icon" /></div>;
  if (error) return <div>{error}</div>;




  return (
    <div className="post-list">
      {capsules.map((capsule) => {
        const now = new Date();
        const openingTime = new Date(capsule.openingTime);

        return (
          <div
            className={`post-item ${capsule.status === "Locked" ? "locked" : ""}`}
            key={capsule.id}
          >
            <div className="post-header">
              <img
                src={user.data.avatarUrl || "/default-avatar.jpeg"}
                alt="avatar"
                className="avatar"
              />
              <div>
                <strong>{capsule.theme}</strong>
                <div className="time">
                  {new Date(capsule.createdAt).toLocaleString()}
                </div>
              </div>
            </div>

            {capsule.status === "Locked" ? (
              <>
                <p className="post-description">{capsule.description}</p>
                {openingTime < now ? (
                  <div className="open-capsule">
                    <button onClick={() => {
                      console.log("Opening capsule:", capsule.id);
                      handleOpenCapsule(capsule.id)
                    }}>
                      This capsule can be opened
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="locked-overlay">
                      <FaLock />
                      <p>This capsule is locked.</p>
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <p className="post-content">{capsule.content}</p>
                <div className="post-images">
                  {capsule.capsuleMedia && capsule.capsuleMedia.length > 0 ? (
                    <div className="media-gallery">
                      {capsule.capsuleMedia?.map((media) => (
                        console.log("Media URL:", media),
                        <img
                          src={media.mediaUrl}
                          alt={`media`}
                          className="media-item"
                          onClick={() => setSelectedImage(media.mediaUrl)}
                        />
                      ))}
                    </div>
                  ) : (
                    <p>No media available for this capsule.</p>
                  )}
                </div>
                {selectedImage && (
                  <div className="image-modal" onClick={() => setSelectedImage(null)}>
                    <img src={selectedImage} alt="full size" />
                  </div>
                )}

                <div className="post-actions">
                  <div className="post-react">
                    <button onClick={() => handleLike(capsule.id)}>
                      {likedCapsules[capsule.id] ? (
                        <FaHeart color="red" />
                      ) : (
                        <FaRegHeart />
                      )}
                    </button>
                  </div>
                  <span onClick={toggleComments} className="comment-icon">
                    {showComments ? <FaRegCommentAlt color="grey" /> : <FaCommentAlt color="grey" />}
                  </span>
                </div>
                <div className="post-reply">
                  <input
                    type="text"
                    placeholder="Write a reply..."
                    value={replies[capsule.id] || ""}
                    onChange={(e) =>
                      setReplies((prev) => ({
                        ...prev,
                        [capsule.id]: e.target.value,
                      }))
                    }
                  />
                  <button onClick={() => handleReply(capsule.id)} disabled={!replies[capsule.id]?.trim()}>
                    <FaReply />
                  </button>
                </div>
                <div className="post-comments">
                  {showComments && capsule.comments && (
                    <ul>
                      {capsule.comments?.map((comment) => (
                        <li key={comment.commentId} className="comment-item"><img src={comment.user?.avatarUrl || "/default-avatar.jpeg"} alt="avatar" /> 
                        <div className="comment-text">{comment.user.displayName}:  {comment.commentText}</div></li>
                      ))}
                    </ul>
                  )}
                </div>
              </>
            )}
          </div>
        );
      })}

      {selectedCapsule && (
        console.log("Selected capsule for modal:", selectedCapsule),
         console.log("Questions for modal:", questions),
         console.log("Modal is opening"),
        <RecallQuestionModal
          capsuleId={selectedCapsule}
          questions={questions}
          onClose={handleModalClose}
          onSuccess={handleModalSuccess}
        />
      )}
    </div>
  );
};

export default MyCapsulePage;